<template>
  <div class="box-exercise">
    <div class="w1240 exercise-wrap">
      <div class="exercise-info">
<!--        <img src="@/assets/img/avator.png" class="info-img" />-->
        <img :src="displayAvatar"  class="info-img" />
        <div class="exercise-name exercise-center">
          {{ userInfo.nickname }}
        </div>
        <div class="exercise-time exercise-center">剩余时间</div>
        <div class="exercise-count-down">{{ countDown }}</div>
      </div>
      <div class="exercise-content">
        <div class="question">
          <div class="stem">
            {{ questionIndex + 1 }}/{{ questionList.length }} &nbsp;&nbsp;{{
              currentQuestion.title
            }}
          </div>
          <!-- 0-选择题(单选) 1-选择题(多选) 2-判断题(0-false 1-true) 3-解答题 -->
          <div v-if="singleArr.includes(+currentQuestion.questionType)">
            <div
              @click="handleSetmOption(index, item.optionName)"
              class="stem-option"
              :class="{ 'setm-option-active': index === setmActive }"
              v-for="(item, index) in JSON.parse(currentQuestion.questionBankOption)"
              :key="index"
            >
              <i></i>{{ item.optionName }}、{{ item.optionValue }}
            </div>
          </div>
          <!-- 多选 -->
          <div v-if="+currentQuestion.questionType === 1">
            <a-checkbox-group @change="handleCheckbox">
              <a-checkbox
                v-for="(item, index) in JSON.parse(currentQuestion.questionBankOption)"
                :key="item.optionName"
                :value="item.optionName + '::' + index"
              >
                {{ item.optionName }}、{{ item.optionValue }}
              </a-checkbox>
            </a-checkbox-group>
          </div>
        </div>
        <div class="exercise-btn">
          <div class="exercise-desc" v-if="+currentQuestion.questionType === 0">
            单项选择题，请选择一项
          </div>
          <div class="exercise-desc" v-if="+currentQuestion.questionType === 1">
            多项选择题，请选择一项或多项
          </div>
          <div class="exercise-desc" v-if="+currentQuestion.questionType === 2">
            判断题，请判断对错
          </div>
          <div class="exercise-desc" v-if="+currentQuestion.questionType === 3">
            解答题，请输入答案
          </div>
          <div class="exercise-send" @click="submitFunc" v-if="isComplete">提交</div>
          <div class="answer">
            <div class="answer-set" @click="handleAnswerSet">
              <i :class="{ setActive: answerSetFlag }"></i>答对自动下一题
            </div>
            <div class="answer-right">
              答对:<span>{{ correctNum }}题</span>
            </div>
            <div class="answer-error">
              答错:<span>{{ faultNun }}题</span>
            </div>
            <div class="answer-acc">
              正确率:<span>{{ accuracy }}</span>
            </div>
            <div class="answer-note">考生注意：做题途中禁止退出，否则成绩不作数</div>
          </div>
        </div>
      </div>
    </div>
    <div class="w1240 answer-info">
      <div class="info-title">答题信息</div>
      <div class="info-list">
        <span
          v-for="(item, index) in questionList"
          :key="index"
          :class="{
            correct: item.correct === 1,
            erroneous: item.correct === 2,
          }"
          >{{ index + 1 }}</span
        >
      </div>
    </div>
    <a-modal
      title=""
      :visible="visible"
      :confirm-loading="confirmLoading"
      :closable="false"
      :maskClosable="false"
    >
      <template slot="footer">
        <div class="footer-btn" @click="handleOk">提交</div>
      </template>
      <textarea
        class="video-opinion"
        placeholder="说一下心得吧~"
        v-model="videoOpinion"
      ></textarea>
    </a-modal>
  </div>
</template>

<script>
import {
  getQuestList,
  getExamSubmit
} from "@/api/UserCenter";
import { mapGetters } from "vuex";
import { toDisplayImageUrl } from "@/utils/workImage";
export default {
  name: "Exercise",
  computed: {
    ...mapGetters(["userInfo","isLogin"]),
    displayAvatar() {
      return toDisplayImageUrl(this.userInfo.avatar) || require("@/assets/img/user.png");
    },
  },
  data() {
    return {
      setmActive: null,
      answerSetFlag: false,
      countDown: "30:00",
      timer: null,
      type: "",
      questionList: [], // 题目列表
      questionIndex: 0,
      chapterId: "",
      singleArr: [0, 2], // 标识为单项选择的
      currentQuestion: {}, // 当前题目信息
      checkedValue: [], // 多选题 选中的选项
      exactness: [], // 正确选项，
      singleAnswer: "", // 单选和判断题的当前答案
      videoOpinion: "", // 心得
      correctNum: 0,
      faultNun: 0,
      accuracy: 0,
      visible: false,
      confirmLoading: false,
      isComplete: true,
      page:1,
      examId:'',
    };
  },
  mounted() {
    // this.type = this.$route.query.type;
    // this.chapterId = this.$route.query.chapterId;
    this.examId = this.$route.params.id;
    console.log("$route", this.examId);
    this.examinationFunc();
    this.setCountDown();
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log("handleOk", this.videoOpinion);
      this.confirmLoading = true;
      this.visible = false;
      this.confirmLoading = false;
      this.artQuestionBankExaminationFunc();
    },

    submitFunc() {
      console.log("submitFunc", this.currentQuestion);
      let current = this.currentQuestion;
      let checkedValue = this.checkedValue;
      if (this.singleArr.includes(+this.currentQuestion.questionType)) {
        if (!this.singleAnswer) {
          this.$message.error("请作答！");
          return;
        }
        if (this.singleAnswer === current.answer) {
          this.updateTopic(1, current);
        } else {
          this.updateTopic(2);
        }
      }
      if (+current.questionType === 1) {
        if (!checkedValue.length) {
          this.$message.error("请作答！");
          return;
        }
        let answerList = checkedValue
          .map((item) => {
            let arr = item.split("::");
            return {
              answer: arr[0],
              id: arr[1],
            };
          })
          .sort((a, b) => {
            return a.id - b.id;
          });
        console.log("arr", answerList);

        let answerStr = "";
        answerList.forEach((item) => {
          answerStr += item.answer;
        });

        if (answerStr === current.answer) {
          this.updateTopic(1, current);
        } else {
          this.updateTopic(2);
        }
      }
    },
    updateTopic(status, current = null) {
      // status 1: 正确   2：错误
      current && this.exactness.push(current);
      this.questionList[this.questionIndex].correct = status;
      if (this.questionIndex === this.questionList.length - 1) {
        this.correctNum = this.exactness.length;
        this.faultNun = this.questionList.length - this.correctNum;
        let result = this.correctNum / this.questionList.length;
        this.accuracy = Math.round(result * 10000) / 100 + "%";
        this.visible = true;
      } else {
        this.questionIndex += 1;
        this.currentQuestion = this.questionList[this.questionIndex];
        this.checkedValue = [];
        this.singleAnswer = "";
        this.setmActive = null;
      }
    },
    handleCheckbox(checkdValue) {
      console.log("checkdValue", checkdValue);
      this.checkedValue = checkdValue;
    },
    artQuestionBankExaminationFunc() {
      let score = this.exactness.reduce((acc, cur) => {
        console.log(acc, cur);
        return acc + parseInt(cur.score);
      }, 0);
      let itemVoList = this.exactness.map((item) => {
        return {
          questionId: item.id,
          submitAnswer: item.answer,
        };
      });
      console.log("scores", score);
      let paramas = {
        chapterId: this.chapterId,
        score,
        type: this.type,
        videoOpinion: this.videoOpinion,
        itemVoList,
      };
      getQuestList(paramas)
        .then((res) => {
          console.log("artQuestionBankExaminationFunc", res);
          this.$message.success("完成测试！");
          this.isComplete = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    examinationFunc() {
      let paramas = {
        examId: this.examId,
        limit: 10,
        page: this.page
      };
      let API = getQuestList(paramas);
      if (+this.type === 2) API = getQuestList();
      API.then((res) => {
        console.log("questionType", res);
        let data = res.data.map((item) => {
          item.correct = null;
          return item;
        });
        this.questionList = data;
        this.currentQuestion = data[0];
      }).catch((err) => {
        console.log(err);
      });
    },
    handleSetmOption(index, answer) {
      this.setmActive = index;
      this.singleAnswer = answer;
    },
    handleAnswerSet() {
      this.answerSetFlag = !this.answerSetFlag;
    },
    setCountDown() {
      let time = 30 * 60;
      this.timer = setInterval(() => {
        time = time - 1;
        let m = parseInt((time / 60) % 60);
        m = m < 10 ? "0" + m : m;
        let s = parseInt(time % 60);
        s = s < 10 ? "0" + s : s;
        if (time === 0) {
          clearInterval(this.timer);
        }
        // 作为返回值返回
        this.countDown = `${m}:${s}`;
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.box-exercise {
  border-top: 1px solid #f2f2f2;
  padding-top: 35px;
  .exercise-wrap {
    display: flex;
    justify-content: space-between;
    .exercise-info {
      width: 132px;
      padding-top: 8px;
      .info-img {
        width: 132px;
        height: 132px;
        border-radius: 50%;
      }
      .exercise-name {
        padding-top: 18px;
        padding-bottom: 66px;
      }
      .exercise-center {
        line-height: 15px;
        font-size: 15px;
        color: #333;
        text-align: center;
      }
      .exercise-time {
        padding-bottom: 23px;
        background: url("../../assets/img/test/count-down.png") no-repeat 24px 0;
        background-size: 15px 15px;
        text-align: left;
        text-indent: 44px;
      }
      .exercise-count-down {
        color: #da514e;
        font-size: 25px;
        text-align: center;
      }
    }
    .exercise-content {
      width: 968px;
      .question {
        margin-bottom: 170px;
        .stem {
          line-height: 36px;
          font-size: 17px;
          color: #333;
          margin-bottom: 24px;
        }
        .stem-option {
          margin-bottom: 27px;
          line-height: 15px;
          font-size: 15px;
          color: #333;
          i {
            display: inline-block;
            width: 9px;
            height: 9px;
            border: 1px solid #aaa;
            border-radius: 50%;
            margin: 0 10px 0 36px;
          }
        }
        .setm-option-active {
          color: #7a2489;
          i {
            display: inline-block;
            width: 9px;
            height: 9px;
            border: 1px solid #7a2489;
            border-radius: 50%;
            background: #7a2489;
            box-shadow: 0 0 4px #7a2489;
          }
        }
      }
      .exercise-btn {
        .exercise-desc {
          margin-bottom: 30px;
          font-size: 13px;
          color: #333;
        }
        .exercise-send {
          width: 111px;
          height: 40px;
          line-height: 40px;
          border-radius: 5px;
          background-color: #7a2489;
          color: #fff;
          font-size: 15px;
          text-align: center;
          margin-bottom: 22px;
          cursor: pointer;
        }
        .answer {
          margin-bottom: 62px;
          display: flex;
          justify-content: left;
          color: #333;
          font-size: 13px;
          & > div {
            line-height: 14px;
          }
          .answer-set {
            // margin-right: 51px;
            flex: 1;
            cursor: pointer;
            i {
              float: left;
              width: 14px;
              height: 14px;
              background: #f2f2f2;
              margin-right: 6px;
              border-radius: 2px;
            }
            & > .setActive {
              background-color: #3fbce9 !important;
              background: url("../../assets/img/test/selected.svg") no-repeat 1px 2px;
              background-size: 14px 11px;
            }
          }
          .answer-right {
            margin-right: 51px;
            span {
              color: #98bf26;
              margin-left: 9px;
            }
          }
          .answer-error {
            margin-right: 51px;
            span {
              color: #da514e;
              margin-left: 9px;
            }
          }
          .answer-acc {
            margin-right: 224px;
            span {
              margin-left: 9px;
            }
          }
          .answer-note {
            color: #3fbce9;
          }
        }
      }
    }
  }
  .answer-info {
    border-top: 1px solid #f2f2f2;
    padding: 37px 0 42px 274px;
    .info-title {
      font-size: 17px;
      color: #333;
      margin-bottom: 23px;
    }
    .info-list {
      display: flex;
      justify-content: left;
      span {
        margin-right: 15px;
        width: 28px;
        height: 28px;
        line-height: 28px;
        border: 1px solid #aaa;
        border-radius: 4px;
        font-size: 13px;
        color: #aaa;
        text-align: center;
        cursor: pointer;
      }
      .correct {
        color: #98bf26;
        border: 1px solid #98bf26;
      }
      .erroneous {
        color: #da514e;
        border: 1px solid #da514e;
      }
    }
  }
}
.footer-btn {
  margin: 0 auto;
  width: 130px;
  height: 40px;
  line-height: 40px;
  background-color: #7a2489;
  border-radius: 4px;
  font-size: 15px;
  text-align: center;
  color: #fff;
}
.video-opinion {
  width: 605px;
  height: 249px;
  border: 1px solid #f2f2f2;
  resize: none;
  padding: 12px;
  line-height: 24px;
}
.ant-modal-content {
  width: 659px !important;
}
.ant-modal-footer {
  padding: 0 0 20px 0 !important;
  border-top: 0;
}
</style>
